module.exports = __webpack_public_path__ + "img/2377793.11e6185f.png";